import PageSpinner from "../../components/spinner/page";
import React from "react";
import { useRouter } from 'next/router';
import Page from "../../lib/page";
import MetaData, {Type} from "../../components/metadata";
import ProductList from "../../components/productList";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import Share from "../../components/share";
import Footer from "../../components/footer";
import Header from "../../components/header";
import Media from "../../components/media";
import IngredientAPI from "../../lib/api/ingredient";
import CategoryList from "../../components/categoryList";
import Template from "../../lib/template";
import PageRenderer from "../../components/page";
import Link from "next/link";
import Texts from "../../lib/texts";
import IngredientTypesHelper from "../../lib/ingredientTypes";
import TrafficLight from "../../components/trafficLight";
import WithAndWithout from "../../components/withAndWithout";

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function Ingredient(props) {
    const router = useRouter();
    const { t } = useTranslation();

    // fallback
    if (router.isFallback) {
        return <PageSpinner />
    }

    // init
    const imageURL = props.ingredient.image ? props.ingredient.image.url : process.env.logoURL;
    const baseURL = '/product/search?i_' + encodeURIComponent(props.ingredient.id) + '=1';
    const title = t('facts.about') + ' ' + ((props.texts && props.texts.title) ? props.texts.title : props.ingredient.translation);
    const lead = (props.texts && props.texts.description) ? props.texts.description : t('ingredient.lead', { ns: 'glossary', ingredient: props.ingredient.translation});

    // render
    return (
        <>
            {/* Metadata */}
            <MetaData
                type={Type.Website}
                title={title}
                description={lead}
                keywords={[props.ingredient.translation]}
                imageURL={null}
                urlOnlyForThisCountry={false}
                canonical={false}
            />

            {/* Header */}
            <Header />

            {/* Content */}
            <div className="container p-4 pt-3 pb-5">
                {/* Header */}
                <div className="row">
                    {/* Symbol */}
                    {/*<svg xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" fill="currentColor"
                             className="bi bi-bounding-box-circles mt-2" viewBox="0 0 16 16">
                            <path
                                d="M2 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM0 2a2 2 0 0 1 3.937-.5h8.126A2 2 0 1 1 14.5 3.937v8.126a2 2 0 1 1-2.437 2.437H3.937A2 2 0 1 1 1.5 12.063V3.937A2 2 0 0 1 0 2zm2.5 1.937v8.126c.703.18 1.256.734 1.437 1.437h8.126a2.004 2.004 0 0 1 1.437-1.437V3.937A2.004 2.004 0 0 1 12.063 2.5H3.937A2.004 2.004 0 0 1 2.5 3.937zM14 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM2 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                        </svg>*/}

                    {/* Title */}
                    <h1 className="mb-2 pb-2 mt-3 text-center text-md-start">
                        {title}

                        {/* Traffic Light */}
                        <div className="mt-2 mt-md-0 ms-md-1 d-md-inline-block align-middle lh-1">
                            <TrafficLight type={props.ingredient.trafficLight} value={' '} size={"small"} />
                        </div>
                    </h1>

                    <div className="col-md-7 col-lg-4 text-md-start">
                        {/* Ingredient-Types */}
                        {/*<div className="d-flex justify-content-center justify-content-md-start mb-4">
                            <IngredientTypes
                                allergenFree={!props.ingredient.ingredientTypes.allergens}
                                vegan={props.ingredient.ingredientTypes.vegan}
                                vegetarian={props.ingredient.ingredientTypes.vegetarian}
                                additiveFree={!props.ingredient.ingredientTypes.additives}
                                id={'ingredient-' + props.ingredient.id}
                                includeTooltip={true}
                            />
                            <IngredientTypeList id={} singular={} ingredientTypes={} />
                        </div>*/}

                        {/* Share */}
                        <div className="row justify-content-center justify-content-md-start">
                            <Share imageURL={imageURL} />
                        </div>
                    </div>

                    {/* Image */}
                    {
                        props.ingredient.image ?
                            <div className="col-12 col-md-5 col-lg-3 mb-3 mb-md-0 mt-4 mt-md-0 text-center">
                                <Media
                                    data={
                                        {
                                            type: 'image',
                                            url: props.ingredient.image.url,
                                            description: props.ingredient.translation,
                                            loader: true,
                                            height: props.ingredient.image.height,
                                            width: props.ingredient.image.width,
                                            priority: true
                                        }
                                    }
                                    figure={false}
                                />
                            </div>
                        : ''
                    }
                </div>

                {/* Lead */}
                <p className={'lead mt-3'}>{lead}</p>

                {/* With & without */}
                {props.ingredient.products && props.ingredient.products.scores && props.ingredient.products.scores.length
                    ?
                    <>
                        <div id={'with-and-without'} className={'mt-5 pt-1 col-12 col-lg-9'}>
                            <h2 className="pb-2 mt-4">{(props.texts && props.texts.score.comparison) ? props.texts.score.comparison : t('score.comparison', { ns: 'glossary', title: props.ingredient.translation})}</h2>
                            <WithAndWithout
                                compareWith={
                                    {
                                        url: '/product/search?i_' + props.ingredient.id + '=1',
                                        name: t('avg.score.type', {ns: 'glossary', title: props.ingredient.translation}),
                                        score: props.ingredient.products.with.score,
                                        ratio: props.ingredient.products.with.ratio,
                                        count: props.ingredient.products.with.count
                                    }
                                }
                                compareWithout={
                                    {
                                        url: '/product/search?i_!' + props.ingredient.id + '=1',
                                        name: t('avg.score.not.type', {ns: 'glossary', title: props.ingredient.translation}),
                                        score: props.ingredient.products.without.score,
                                        ratio: props.ingredient.products.without.ratio,
                                        count: props.ingredient.products.without.count
                                    }
                                }
                            />
                        </div>
                    </>
                    : ''
                }

                {/* Categories */}
                {props.ingredient.categories && props.ingredient.categories.length
                    ?
                    <div id={'categories'} className={'mt-5 pt-5 col-12 col-lg-9'}>
                        <h2 className="pb-2">{(props.texts && props.texts.categories.proportion) ? props.texts.categories.proportion : t('ingredient.ratio.category', { ns: 'glossary', ingredient: props.ingredient.translation})}</h2>
                        <CategoryList categories={props.ingredient.categories} embed={true} />
                    </div>
                    : ''
                }

                {/* Products */}
                {props.ingredient.products && props.ingredient.products.scores && props.ingredient.products.scores.length
                    ?
                    <>
                    <div id={'best-products'} className={'mt-5 pt-1 col-12 col-lg-9'}>
                        <h2 className="pb-2 mt-4">{(props.texts && props.texts.best.products) ? props.texts.best.products : t('ingredient.healthiest.products', { ns: 'glossary', ingredient: props.ingredient.translation})}</h2>
                        <ProductList id={'best-products'} products={props.ingredient.products.scores} />
                        {props.ingredient.products.with.count > 6
                            ?
                            <div className={'text-center mt-1'}>
                                <Link href={baseURL + '&sort=score_desc'} className={'text-center btn btn-primary'}>
                                    {t('view.all.products.count', {ns: 'glossary', count: props.ingredient.products.with.count})}
                                </Link>
                            </div>
                            : ''
                        }
                    </div>
                    <div id={'highest-products'} className={'mt-5 pt-4 col-12 col-lg-9'}>
                        <h2 className="pb-2 mt-4">{(props.texts && props.texts.highest.products) ? props.texts.highest.products : t('highest.products', { ns: 'glossary', title: props.ingredient.translation})}</h2>
                        <ProductList id={'highest-products'} products={props.ingredient.products.highest} />
                        {props.ingredient.products.with.count > 6
                            ?
                            <div className={'text-center mt-1'}>
                                <Link href={baseURL + '&sort=ingredient_proportion_desc'} className={'text-center btn btn-primary'}>
                                    {t('view.all.products.count', {ns: 'glossary', count: props.ingredient.products.with.count})}
                                </Link>
                            </div>
                            : ''
                        }
                    </div>
                    <div id={'lowest-products'} className={'mt-5 pt-4 col-12 col-lg-9'}>
                        <h2 className="pb-2 mt-4">{(props.texts && props.texts.lowest.products) ? props.texts.lowest.products : t('lowest.products', { ns: 'glossary', title: props.ingredient.translation})}</h2>
                        <ProductList id={'lowest-products'} products={props.ingredient.products.lowest} />
                        {props.ingredient.products.with.count > 6
                            ?
                            <div className={'text-center mt-1'}>
                                <Link href={baseURL + '&sort=ingredient_proportion_asc'} className={'text-center btn btn-primary'}>
                                    {t('view.all.products.count', {ns: 'glossary', count: props.ingredient.products.with.count})}
                                </Link>
                            </div>
                            : ''
                        }
                    </div>
                    </>
                    : ''
                }

                {/* Blog-Posts */}
                {props.template.type
                    ?
                    <div id={'posts'} className={'mt-5 pt-4 col-12 col-lg-9'}>
                        <PageRenderer
                            type={props.template.type}
                            date={props.template.date}
                            data={props.template.data}
                            embed={true}
                        />
                    </div>
                    : ''
                }
            </div>

            {/* Footer */}
            <Footer />
        </>
    )
}

/**
 *
 * @param context
 * @returns {Promise<{notFound: boolean}>}
 */
export async function getStaticProps(context) {
    let page = new Page;
    page.init(context.locale);

    let ingredientAPI = new IngredientAPI(
        page.language,
        page.country
    );

    let ingredient = {};
    const data = await ingredientAPI.selectById(context.params.id);

    if(data && 'ok' === data.header.status && data.body.ingredient) {
        ingredient = data.body.ingredient;
        data.body.ingredient.products.scores.forEach(function(product) {
            product.link = '/' + context.locale + '/product/' + encodeURIComponent(product.id);
        })
        data.body.ingredient.products.highest.forEach(function(product) {
            product.link = '/' + context.locale + '/product/' + encodeURIComponent(product.id);
        })
        data.body.ingredient.products.lowest.forEach(function(product) {
            product.link = '/' + context.locale + '/product/' + encodeURIComponent(product.id);
        })

        const ingredientTypesHelper = new IngredientTypesHelper();
        data.body.ingredient.ingredientTypes = ingredientTypesHelper.determine(data.body.ingredient.types);
    } else {
        throw Error('Unable to retrieve ingredient');
    }

    let texts = new Texts();
    await texts.init(
        page.language,
        'ingredient/' + data.body.ingredient.id
    );

    let template = new Template;
    await template.init(
        page.language,
        'blog/' + data.body.ingredient.name
    );

    if (template.found) {
        await template.enrichData(context.locale);
    }

    return {
        props: {
            ...(await serverSideTranslations(context.locale, ['common', 'languages', 'countries', 'glossary', 'ingredients', 'ingredients', 'traces', 'ingredient-types'])),
            "ingredient": ingredient,
            "language": page.language,
            "country": page.country,
            "locale": page.locale,
            "template": {
                "type": template.found ? template.type : null,
                "date": template.found ? template.date : null,
                "data": template.found ? template.data : null
            },
            "texts": texts.found ? texts.data : null
        }, // will be passed to the page component as props
        revalidate: 86400, // In seconds
    };
}

/**
 *
 * @returns {Promise<{or: boolean, paths: [{params: {}}], fallback: boolean}>}
 */
export async function getStaticPaths() {
    return {
        paths: [],
        fallback: true
    };
}